import {RootState} from '../../rootReducer';
import {ExtraService} from './types';

export const getExtras = (state: RootState) => state.data.extras.extras;

export const getExtraServices = (category: ExtraService['category']) => (state: RootState) =>
  state.data.extras.extraServicesByCategoryByBuilding[category];

export const getExtraServicesLoadingStatus = (state: RootState) => state.data.extras.extraServicesLoadingStatus;
